(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dot-map-renderer"] = factory();
	else
		root["dot-map-renderer"] = factory();
})(globalThis, function() {
return 